export default __webpack_public_path__ + "static/media/Logo_FR_couleur_fond.76cab537.jpg";